<template>
  <modal
    width="1000px"
    height="649px"
    name="survey-taker-modal"
    class="survey-taker-modal"
  >
    <div class="modalHeader">
      <div class="title">{{ title }}</div>

      <div class="close" @click="hide()">
        <font-awesome-icon icon="times" />
      </div>
    </div>
    <div class="questions-container">
      <div
        class="area-container"
        v-for="(area, index_area) in areas"
        :key="index_area"
      >
        <div class="area-title">
          <div class="container">
            <img :src="getImgUrl(index_area)" />
            {{ index_area }}: {{ area.subtitle }}
          </div>
        </div>
        <div
          class="questions container"
          v-for="(question, index_question, i) in questions[index_area]"
          :key="index_question"
        >
          <div class="question-container">
            <div class="question-text-container">
              <div class="question col">
                <div class="question-category">
                  {{ calculateQuestionNumber(i, index_area) }}. {{ question.question_category }}:
                </div>
                <div class="question-text">{{ question.question_text }}</div>
              </div>
            </div>
            {{ question.respondents }}
            <div class="row answer">
              <div class="average-percentage-details col-5 row">
                <div class="area-average-percentage col-4">
                  <CircleProgressBar
                    :percentage="
                      scoreToPercentage(
                        question.score_accumulated,
                        question.total_responses
                      )
                    "
                    :color="question.color"
                  />
                </div>
                <div
                  class="area-average-label col-8"
                  :style="{ color: question.color }"
                >
                  {{ question.value }}
                </div>
              </div>
              <div class="answers-container col">
                <div
                  class="answer-details col-2"
                  v-for="(answer, index_answer) in question.answers"
                  :key="index_answer"
                >
                  <div class="answer-count">{{ answer.count }}</div>
                  <div class="answer-text">{{ answer.answer_text }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUser } from "@fortawesome/pro-regular-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import CircleProgressBar from "@/components/common/CircleProgressBar";
import { AREAS, AREAS_SUBTITLES } from "@/services/constants";
import { getAreaIconUrlByName } from "@/services/utils";

library.add(faTimes);
library.add(faUser);

export default {
  props: {
    title: { type: String },
    presentation_id: { type: String },
    respondents: { type: Number },
    areas: { type: Object },
    questions: { type: Array },
    resultsModalData: { type: Array },
    isAdmin: { type: Boolean },
    priorityList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  name: "DashboardModal",
  data() {
    return {};
  },
  components: {
    CircleProgressBar,
  },
  computed: {
    numQuestionsByArea() {
      return {
        Content: Object.keys(this.questions['Content'] || {}).length,
        Visuals: Object.keys(this.questions['Visuals'] || {}).length,
        Delivery: Object.keys(this.questions['Delivery'] || {}).length,
        Connection: Object.keys(this.questions['Connection'] || {}).length
      };
    }
  },
  methods: {
    show() {
      this.$modal.show("survey-taker-modal");
    },
    hide() {
      this.$modal.hide("survey-taker-modal");
    },
    shouldRenderTooltip: function (respondents) {
      return respondents.length > 0 && respondents[0] !== "";
    },
    getImgUrl: getAreaIconUrlByName,
    scoreToPercentage(score, total_responses) {
      if (total_responses === 0) return 0;
      return Math.floor(score / total_responses);
    },
    calculateQuestionNumber(questionIndex, area) {
      let accumulated = 1;
      let shouldBreak = false;
      Object.keys(this.numQuestionsByArea).forEach(key => {
        if(key === area) shouldBreak = true;
        if(!shouldBreak) accumulated += this.numQuestionsByArea[key];
      });
      return questionIndex + accumulated;
    },
  },
  mounted() {},
};
</script>
<style lang="less">
@import "../../assets/components/dashboardList/dashboardModal.less";
</style>
